import { initializeApp } from 'firebase/app'
import {
  connectFirestoreEmulator,
  // doc,
  getFirestore,
  // setDoc,
} from 'firebase/firestore'
import {
  browserLocalPersistence,
  getAuth,
  GoogleAuthProvider,
  GithubAuthProvider,
  setPersistence,
  connectAuthEmulator,
} from 'firebase/auth'
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions'
import { getMessaging } from 'firebase/messaging'
// web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  vapidKey: import.meta.env.VITE_VAPID_API_KEY,
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const db = getFirestore(app)
const functions = getFunctions(app)
const messaging = getMessaging(app) // Add messaging instance

// Configure Google provider
const googleProvider = new GoogleAuthProvider()
googleProvider.setCustomParameters({
  prompt: 'select_account',
})
const githubProvider = new GithubAuthProvider()
// Set persistence
setPersistence(auth, browserLocalPersistence)
// Connect to emulators in development
if (import.meta.env.DEV) {
  console.log('🔥 Connecting to Firebase emulators...')

  // Use 127.0.0.1 instead of localhost for better reliability
  connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
  connectFirestoreEmulator(db, '127.0.0.1', 8080)
  connectFunctionsEmulator(functions, '127.0.0.1', 5001)
}
// const saveToken = async (userId: string, token: string) => {
//   await setDoc(doc(db, 'userProfiles', userId), { token }, { merge: true })
// }
// saveToken(
//   'testUser123',
//   'dRodIk282zwxTnYy61HfFe:APA91bELF5hKk6gQzlUpUPqRDT2XLft_kJjShd_w_KejOqp2LQFvBkruClWUvuSHqrEOvk5AJOCQrPEIAGDo70p8oKapZYbaXvoiyjpitdtbSBBbbMbsPcY'
// )
export { auth, db, googleProvider, githubProvider, messaging }
